import type { VGL_ERROR_CODE } from '@/services/errorHandler/errorCodes';
import {
  VglErrorMessages,
  VglUserErrorMessages,
} from '@/services/errorHandler/errorMessages';
import type {
  VGL_ERROR_HANDLER_SERVICE,
  VglErrorOptions,
} from '@/services/errorHandler/types';

export class VglError extends Error {
  private readonly userModalMessage: string | undefined;

  private readonly userModalTitle: string | undefined;

  private readonly isNonClosableUserModal: boolean | undefined;

  private readonly errorCallback: (() => void) | undefined;

  private readonly errorCode: VGL_ERROR_CODE;

  private readonly skipServiceHandler: VGL_ERROR_HANDLER_SERVICE[] | undefined;

  private readonly additionalData: unknown | undefined;

  private readonly additionalMessage: string | undefined;

  constructor(code: VGL_ERROR_CODE, options: VglErrorOptions = {}) {
    super(`Code: ${code} - ${VglErrorMessages[code] ?? 'no message'}`, {
      cause: options?.cause instanceof Error ? options?.cause : undefined,
    });
    this.userModalMessage = options.userModalMessage;
    this.userModalTitle = options.userModalTitle;
    this.isNonClosableUserModal = options.isNonClosableUserModal;
    this.errorCallback = options.errorCallback;
    this.errorCode = code;
    this.skipServiceHandler = options.skipServiceHandler;
    this.additionalData = options.additionalData;
    this.additionalMessage = options.additionalErrorMessage;
  }

  /**
   * we can provide a custom modal message by using the second constructor parameter - as a fallback
   * we try to find the correct message in the VglUserErrorMessages definition.
   */
  getUserModalMessage(): string | undefined {
    return this.userModalMessage ?? VglUserErrorMessages[this.errorCode];
  }

  getUserModalTitle(): string | undefined {
    return this.userModalTitle;
  }

  getIsNonClosableUserModal(): boolean | undefined {
    return this.isNonClosableUserModal;
  }

  getErrorCallback(): (() => void) | undefined {
    return this.errorCallback;
  }

  getServiceHandlerToSkip(): VGL_ERROR_HANDLER_SERVICE[] {
    return this.skipServiceHandler ?? [];
  }

  getAdditionalData(): unknown | undefined {
    return this.additionalData;
  }

  getErrorCode(): VGL_ERROR_CODE {
    return this.errorCode;
  }

  getAdditionalMessage(): string | undefined {
    return this.additionalMessage;
  }
}
